module.exports = __webpack_public_path__ + "static/media/vail-11.5dfdf93d.jpg";